window.IndeedCampaignsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['JobDistributorServerBaseURL']);

    self.login = function (code, employer, redirectUrl) {
        var defer = $q.defer();
        var payload = {
            authorization_code: code,
            employer: employer,
            redirect_uri: redirectUrl
        };

        _protected.request('indeed/login', 'POST', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.checkLogin = function () {
        var defer = $q.defer();

        _protected.request('indeed/login/check', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.logout = function () {
        var defer = $q.defer();

        _protected.request('indeed/logout', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getCampaigns = function (status, perPage, start, includeCreatedDate) {
        var defer = $q.defer();
        var params = {
            status: status,
            perPage: perPage,
            start: start,
            include_created_date: includeCreatedDate
        };

        if (start) {
            params['start'] = start;
        }
        _protected.request('indeed/campaigns?perPage=30', 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getCampaign = function (id) {
        var defer = $q.defer();

        _protected.request('indeed/campaigns/' + id, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getJobSources = function () {
        var defer = $q.defer();

        _protected.request('indeed/accounts/sources', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getJobsList = function (boardCode, excludeCampaignId) {
        var defer = $q.defer();
        var params = {
            board_code: boardCode,
            exclude_campaign_id: excludeCampaignId,
        };

        _protected.request(publicConfiguration.APIServerBaseURL + 'distributor/jobs', 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.createCampaign = function (data) {
        var defer = $q.defer();
        var payload = {
            name: data.campaignName,
            budget: +data.budget,
            start_date: moment(data.startDate).format('YYYY-MM-DD'),
            end_date: moment(data.endDate).format('YYYY-MM-DD'),
            job_source_id: data.jobsSource.id || 'harri',
            jobs: data.jobs
        };

        _protected.request('indeed/campaigns', 'POST', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateCampaign = function (campaignId, jobs) {
        var defer = $q.defer();
        var payload = {
            jobs: jobs
        };

        _protected.request('indeed/campaigns/' + campaignId, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };
};
